// src/api/client.ts
import axios from 'axios';
import { config } from '../utils/config';

// Create axios instance with base configuration
export const apiClient = axios.create({
    baseURL: config.API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000 // 30 second timeout
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
    (config) => {
        // Add auth token if available
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('API Request Error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle specific error cases
        if (error.response) {
            // Log error details for debugging
            console.error('API Response Error:', {
                status: error.response.status,
                data: error.response.data,
            });

            // Handle unauthorized
            if (error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.href = '/login';
                return Promise.reject(new Error('Authentication required. Please log in again.'));
            }

            // Handle resource not found
            if (error.response.status === 404) {
                return Promise.reject(new Error('The requested resource was not found.'));
            }

            // Handle server errors
            if (error.response.status >= 500) {
                return Promise.reject(new Error('Server error. Please try again later.'));
            }

            // Return the server's error message if available
            if (error.response.data?.detail) {
                return Promise.reject(new Error(error.response.data.detail));
            }
        } else if (error.request) {
            // The request was made but no response was received
            console.error('API Request Error (No Response):', error.request);
            return Promise.reject(new Error('No response from server. Please check your network connection.'));
        } else {
            // Something happened in setting up the request
            console.error('API Setup Error:', error.message);
        }
        
        return Promise.reject(error);
    }
);

export default apiClient;